/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddSyncEntityForAccountHolderRequest} from '@cash-web/protos/squareup/cash/clientsync/service.pb'
import {AddSyncEntityForAccountHolderResponse} from '@cash-web/protos/squareup/cash/clientsync/service.pb'


export const addSyncEntityForAccountHolder = (request:AddSyncEntityForAccountHolderRequest, options?: CashRequestOptions) => post<AddSyncEntityForAccountHolderRequest, AddSyncEntityForAccountHolderResponse>("/2.0/cash/add-sync-entity-for-account-holder", request, {...options, rejectOnError: true })